import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../ui/Button";
import type { DiceRollResult } from "../../types/game";
import { useLanguage } from "../../i18n/LanguageContext";

const DICE_FACES = ["", "1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣"];

interface Props {
  onRoll: () => DiceRollResult | void;
  result: DiceRollResult | null;
  disabled?: boolean;
}

export default function DiceRoller({ onRoll, result, disabled }: Props) {
  const { t } = useLanguage();
  const [rolling, setRolling] = useState(false);
  const [face, setFace] = useState(1);

  const handleRoll = async () => {
    if (rolling || disabled) return;
    setRolling(true);

    // Animate random faces
    let steps = 0;
    const anim = setInterval(() => {
      setFace(Math.floor(Math.random() * 6) + 1);
      steps++;
      if (steps >= 10) {
        clearInterval(anim);
        setRolling(false);
        onRoll();
      }
    }, 80);
  };

  return (
    <div className="flex flex-col items-center gap-3">
      <motion.div
        className="text-7xl cursor-default"
        animate={rolling ? { rotate: [0, 15, -15, 10, -10, 0] } : {}}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        {DICE_FACES[result ? result.roll : face]}
      </motion.div>

      <AnimatePresence>
        {result && (
          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="font-display font-black text-2xl text-white">{t.action[result.label]}</div>
            <div className={`font-display font-bold text-xl ${result.netGain >= 0 ? "text-green-400" : "text-red-400"}`}>
              {result.netGain >= 0 ? "+" : ""}{result.netGain} 🪙
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {!result && (
        <Button onClick={handleRoll} disabled={disabled || rolling} size="lg">
          {rolling ? t.action.rolling : t.action.rollDice}
        </Button>
      )}
    </div>
  );
}
